// @ts-nocheck

import * as Sentry from '@sentry/react';
import { useEffect, useState } from 'react';

import { __ } from '../../../i18n/l10n';

const loadAsset = (path) => {
  return new Promise((resolve, eject) => {
    const img = new Image();
    img.setAttribute('crossOrigin', 'anonymous');
    img.addEventListener(
      'load',
      function onLoad() {
        img.removeEventListener('load', onLoad, false);
        resolve(img);
      },
      false,
    );

    img.addEventListener(
      'error',
      function onError() {
        img.removeEventListener('error', onError, false);
        eject();
      },
      false,
    );
    img.src = path;
  });
};

const useLoadImages = (assets, shouldRetry) => {
  const [images, setImages] = useState({});
  const [isImagesLoaded, setIsImagesLoaded] = useState(false);
  const [isImagesLoadedError, setIsImagesLoadedError] = useState(false);

  useEffect(() => {
    let didCancel = false;

    const setIsImagesLoadedSafe = (value) => {
      !didCancel && setIsImagesLoaded(value);
    };

    const setImagesSafe = (images) => {
      !didCancel && setImages(images);
    };

    (async () => {
      const imagesTmp = {};

      try {
        const promesses = Object.keys(assets).map(async (key) => {
          const img = await loadAsset(assets[key]);
          imagesTmp[key] = img;
        });

        await Promise.all(promesses);
        setImagesSafe(imagesTmp);
        setIsImagesLoadedSafe(true);
      } catch (error) {
        console.warn('Some critical images are not available:', error);
        Sentry.captureMessage('unable to load image', { extra: { message: '', images: Object.keys(assets) } });
        setIsImagesLoadedSafe(false);
        setIsImagesLoadedError({
          errorType: __('An error has occured'),
          errorText: __('We were unable to generate your final image'),
        });
      }
    })();
    return () => (didCancel = true);
  }, [assets, shouldRetry]);
  return {
    isImagesLoaded,
    isImagesLoadedError,
    images,
  };
};

export default useLoadImages;
